import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
// import Close from "@material-ui/icons/Close";
// import Assignment from "@material-ui/icons/Assignment";
import Face from "@material-ui/icons/Face";
import Phone from "@material-ui/icons/Phone";
import Home from "@material-ui/icons/Home";
import Edit from "@material-ui/icons/Edit";
// import Timeline from "@material-ui/icons/Timeline";
// import Code from "@material-ui/icons/Code";
// import Group from "@material-ui/icons/Group";
import Email from "@material-ui/icons/Email";
import Check from "@material-ui/icons/Check";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
// import Card from "components/Card/Card.jsx";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Slide from '@material-ui/core/Slide';

import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.jsx";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class AddContactMainData extends React.Component {
  // constructor(props) {
  //   super(props);
  //
  // }


  render() {
    const { classes, propertyData } = this.props;
    return (
            <div>
              <GridContainer>

                <GridItem xs={6} sm={6} md={6} className={classes.mlAuto}>
                  <TextField
                      id="name"
                      label="Name"
                      name="name"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={this.props.propertyData.name.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />

                </GridItem>
                <GridItem xs={6} sm={6} md={6} className={classes.mlAuto}>
                  <TextField
                      id="surname"
                      label="Surname"
                      name="surname"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={this.props.propertyData.surname.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />
                </GridItem>

                </GridContainer>
                <GridContainer>
                <GridItem xs={6} sm={6} md={6} className={classes.mrAuto}>
                <TextField
                    id="phone"
                    label="Phone"
                    name="phone"
                    className={classes.textField}
                    margin="normal"
                    fullWidth
                    value={this.props.propertyData.phone.value}
                    onChange={(e) => this.props.changeHandler(e)}
                  />
                  </GridItem>
                  <GridItem xs={6} sm={6} md={6} className={classes.mrAuto}>
                  <TextField
                      id="email"
                      label="Email"
                      name="email"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      value={this.props.propertyData.email.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />
                </GridItem>

              </GridContainer>

              <GridContainer>

                <GridItem xs={12} sm={12} md={12} className={classes.mrAuto}>
                  <TextField
                      id="address"
                      label="Address"
                      name="address"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      multiline
                      rows={2}
                      variant="outlined"
                      value={this.props.propertyData.address.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />
                </GridItem>

              </GridContainer>

              <GridContainer>

                <GridItem xs={12} sm={12} md={12} className={classes.mrAuto}>
                  <TextField
                      id="description"
                      label="Description"
                      name="description"
                      className={classes.textField}
                      margin="normal"
                      fullWidth
                      multiline
                      rows={2}
                      variant="outlined"
                      value={this.props.propertyData.description.value}
                      onChange={(e) => this.props.changeHandler(e)}
                    />
                </GridItem>


              </GridContainer>

            </div>

    );
  }
}

export default withStyles(javascriptStyles)(AddContactMainData);
